export const TOKEN_ORIGIN = {
  ALLPLAN: 'allplan',
  GRAPHISOFT: 'graphisoft',
} as const;

export type TokenOrigin = (typeof TOKEN_ORIGIN)[keyof typeof TOKEN_ORIGIN];
